@if (model) {
  @if (
    calendarView === CalendarView.DayGrid ||
    calendarView === CalendarView.WeekGrid ||
    (calendarView === CalendarView.MonthGrid && model.fixInterval !== null)
  ) {
    <div
      #dragEdge
      appTimeBlockDragResize
      [dragPart]="dragPart"
      [timeBlockId]="timeBlockComponentItem.timeBlockModel.id"
      [timeBlockPart]="timeBlockComponentItem.timeBlockModel.partNumber"
      class="resize-handle k-pos-absolute tb"
      [ngClass]="dragPart"
      (click)="$event.stopPropagation()"
      [attr.data-drag-edge]="dragPart"
    >
      <span class="drag-indicator k-w-full k-h-full text-center position-absolute tb">
        <kendo-svg-icon
          class="symbol !k-pos-absolute tb k-right-0"
          [ngClass]="
            timeBlockComponentItem.timeBlockModel.fixInterval !== null
              ? 'k-top-0 k-bottom-0'
              : 'k-rotate-90  k-left-0'
          "
          [icon]="handleDragIcon"
          size="small"
          [flip]="'vertical'"
        ></kendo-svg-icon>
      </span>
    </div>
  }
}
